import React, { useEffect, useState } from 'react';
import {useParams} from 'react-router-dom'
import { useAppSelector } from "../../redux/hooks";
import Hooks from "../utils/hooks";
import { Spin } from 'antd';

const spinnerStyles:any = {
    position:"absolute",
    left: 0,
    right: 0, 
    top:'40%',
    marginLeft: "auto", 
    marginRight: "auto",
  }
const SousTitrage = () => {
  const params = useParams<any>()
  const [loadingTitrage, setLoadingTitrage] = useState(true)
  const {  getsousTitrageUrl } = Hooks();
  const urlTitrage = useAppSelector((state) => state.MediaReducer.urlEditor);
  useEffect(()=>{
    (async()=>{
        await getsousTitrageUrl(params?.id);
        setLoadingTitrage(false)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[params?.id])
  return (
    <>
        {loadingTitrage 
      ? <Spin style={spinnerStyles} size="large" />
      : <iframe
          title={urlTitrage}
          className="iframeVideo"
          id="iframe_list"
          allowFullScreen
          frameBorder="0"
          src={urlTitrage}
        ></iframe>
      }
    </>
  )
}

export default SousTitrage